module.exports = __webpack_public_path__ + "static/img/gengduo.81abf552.png";